
export const SAVE_H4FORMS_STARTED = "SAVE_H4FORMS_STARTED";
export const SAVE_H4FORMS_SUCCESS = "SAVE_H4FORMS_SUCCESS";
export const SAVE_H4FORMS_FAILED = "SAVE_H4FORMS_FAILED";

export const UPDATE_H4FORMS_STARTED = "UPDATE_H4FORMS_STARTED";
export const UPDATE_H4FORMS_SUCCESS = "UPDATE_H4FORMS_SUCCESS";
export const UPDATE_H4FORMS_FAILED = "UPDATE_H4FORMS_FAILED";

export const GET_H4FORMS_SUCCESS = "GET_H4FORMS_SUCCESS";
export const GET_H4FORMS_FAILED = "GET_H4FORMS_FAILED";
export const GET_H4FORMS_STARTED = "GET_H4FORMS_STARTED";



export const SAVE_H4FORMSTRACKING_STARTED = "SAVE_H4FORMSTRACKING_STARTED";
export const SAVE_H4FORMSTRACKING_SUCCESS = "SAVE_H4FORMSTRACKING_SUCCESS";
export const SAVE_H4FORMSTRACKING_FAILED = "SAVE_H4FORMSTRACKING_FAILED";

export const UPDATE_H4FORMSTRACKING_STARTED = "UPDATE_H4FORMSTRACKING_STARTED";
export const UPDATE_H4FORMSTRACKING_SUCCESS = "UPDATE_H4FORMSTRACKING_SUCCESS";
export const UPDATE_H4FORMSTRACKING_FAILED = "UPDATE_H4FORMSTRACKING_FAILED";

export const GET_H4FORMSTRACKING_SUCCESS = "GET_H4FORMSTRACKING_SUCCESS";
export const GET_H4FORMSTRACKING_FAILED = "GET_H4FORMSTRACKING_FAILED";
export const GET_H4FORMSTRACKING_STARTED = "GET_H4FORMSTRACKING_STARTED";


export const GET_H4FORMS539PDF_SUCCESS = "GET_H4FORMS539PDF_SUCCESS";
export const GET_H4FORMS539PDF_FAILED = "GET_H4FORMS539PDF_FAILED";
export const GET_H4FORMS539PDF_STARTED = "GET_H4FORMS539PDF_STARTED";


export const GET_H4FORMS539APDF_SUCCESS = "GET_H4FORMS539APDF_SUCCESS";
export const GET_H4FORMS539APDF_FAILED = "GET_H4FORMS539APDF_FAILED";
export const GET_H4FORMS539APDF_STARTED = "GET_H4FORMS539APDF_STARTED";
 

export interface IVisaCareH4Case {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    CaseInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}


export const createH4PetitionerDetails = (h4formsCreateInput: any) => {
 
    return {
        type: SAVE_H4FORMS_STARTED,
        payload: 'status',
        input: h4formsCreateInput
    };
};
export const updateH4PetitionerDetails = (h4formsUpdateInput: any) => {
   
    return {
        type: UPDATE_H4FORMS_STARTED,
        payload: 'status',
        input: h4formsUpdateInput
    };
};
export const getH4PetitionerDetails = (caseId) => {
 
    return {
        type: GET_H4FORMS_STARTED ,
        payload: 'Value',
        input:caseId
    };
};

export const caseflowH4CaseTrackingCreate = (h4formsTrackingCreateInput: any) => {
 
    return {
        type: SAVE_H4FORMSTRACKING_STARTED,
        payload: 'status',
        input: h4formsTrackingCreateInput
    };
};
export const caseflowH4CaseTrackingUpdate = (h4formsTrackingUpdateInput: any) => {
 
    return {
        type: UPDATE_H4FORMSTRACKING_STARTED,
        payload: 'status',
        input: h4formsTrackingUpdateInput
    };
};
export const getCaseflowH4CaseTracking = (caseId) => {
 
    return {
        type: GET_H4FORMSTRACKING_STARTED ,
        payload: 'Value',
        input:caseId
    };
};

export const h4FormPdfSubmit = (caseId,id,companyCode,dependantType) => {
 
    return {
        type: GET_H4FORMS539APDF_STARTED,
        payload: 'Value',
        input:caseId, 
        inputParam:id,
        inputParamCompanyCode:companyCode,
        inputParamDependantType:dependantType
    };
};
